import { sbEditable } from '@storyblok/storyblok-editable';
import classNames from 'classnames';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import Image from '../../atoms/image/Image';
import styles from './ImageGridFluid.module.scss';
import type { ImageGridFluidProps } from './ImageGridFluid.data';
import useThemeScrollBlock from '../../../hooks/useThemeScrollBlock';

export default function ImageGridFluid({ blok, ref, ...props }: ImageGridFluidProps): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;
  useThemeScrollBlock(elementRef, blok.use_accent_color);

  return (
    <div
      ref={elementRef}
      className={classNames(
        styles.imageGridFluid,
        props.className,
        'grid-gutter',
        'max-content-width',
      )}
      {...sbEditable(blok)}
    >
      {blok?.images?.map((image, index) => (
        <Image
          key={image.id}
          src={image.filename}
          srcDesktop={image.filename}
          sizes="40vw"
          innerTransition={
            blok.no_inner_parallax
              ? undefined
              : {
                  type: 'parallax',
                  config: {
                    speed: index % 2 === 0 ? 1 : -1,
                  },
                }
          }
          transition={{
            type: 'parallax',
            config: {
              speed: ((index % 3) + 0.5) * (index % 2 === 0 ? 1 : -1),
            },
          }}
          className={classNames(styles.item)}
          alt={image.alt}
        />
      ))}
    </div>
  );
}
